import TrimbleMaps, { LngLatLike } from '@trimblemaps/trimblemaps-js';
import { MapRegion } from '../_models/trimblemaps';

export interface Locate {
  center: LngLatLike;
  zoom: number;
  region: MapRegion;
}

export function getRegionSpecificMapInfo(region: string): Locate {
  region = region?.toLocaleLowerCase();
  switch (region) {
    case TrimbleMaps.Common.Region.NA:
      return {
        center: [-76.829705, 39.301864],
        zoom: 4,
        region: TrimbleMaps.Common.Region.NA,
      };
    case TrimbleMaps.Common.Region.AF:
      return {
        center: [16.618583, 11.775136],
        zoom: 3.66,
        region: TrimbleMaps.Common.Region.AF,
      };
    case TrimbleMaps.Common.Region.AS:
      return {
        center: [85.154813, 24.826157],
        zoom: 4,
        region: TrimbleMaps.Common.Region.AS,
      };
    case TrimbleMaps.Common.Region.EU:
      return {
        center: [14.303854, 48.13407],
        zoom: 4,
        region: TrimbleMaps.Common.Region.EU,
      };
    case TrimbleMaps.Common.Region.ME:
      return {
        center: [49.707044, 22.067637],
        zoom: 4,
        region: TrimbleMaps.Common.Region.ME,
      };
    case TrimbleMaps.Common.Region.OC:
      return {
        center: [132.646275, -26.807662],
        zoom: 4,
        region: TrimbleMaps.Common.Region.OC,
      };
    case TrimbleMaps.Common.Region.SA:
      return {
        center: [-57.682028, -11.750582],
        zoom: 4,
        region: TrimbleMaps.Common.Region.SA,
      };
    case TrimbleMaps.Common.Region.WW:
      return {
        center: [5.95591, 20.218474],
        zoom: 1.5,
        region: TrimbleMaps.Common.Region.WW,
      };
    default:
      return {
        center: [-76.829705, 39.301864],
        zoom: 4,
        region: TrimbleMaps.Common.Region.NA,
      };
  }
}
